// Only modify this value when a localStorage reset needs to be forced
const storageVersion = 'v1.1.4';

export default storageVersion;
